import type { FC } from "react"

import type { WarehouseShelving } from "@/graphql/codegen/graphql"

interface WarehouseShelvingInfoProps {
  shelving: WarehouseShelving
  className?: string
}

const WarehouseShelvingInfo: FC<WarehouseShelvingInfoProps> = ({ shelving, className }) => (
  <div data-testid='shelving-info' className={className}>
    <dl className='grid w-full grid-cols-[1fr_1fr] gap-x-2.5 px-6 text-sm/[1.25] tracking-[0.17px] text-gray-700'>
      <dt className='font-bold'>Company Name</dt>
      <dd data-testid='company-name'>{shelving.company?.name}</dd>
      <dt className='font-bold'>Company ID</dt>
      <dd data-testid='company-id'>{shelving.company?.externalSystemId}</dd>
      <dt className='font-bold'>Warehouse ID</dt>
      <dd data-testid='warehouse-id'>{shelving.warehouseArea?.externalSystemId}</dd>
      <dt className='font-bold'>Location</dt>
      <dd data-testid='location'>{shelving.code}</dd>
      {shelving.aisleCode && (
        <>
          <dt className='font-bold'>Aisle Code</dt>
          <dd data-testid='aisle'>{shelving.aisleCode}</dd>
        </>
      )}
      {shelving.sectionCode && (
        <>
          <dt className='font-bold'>Section Code</dt>
          <dd data-testid='section'>{shelving.sectionCode}</dd>
        </>
      )}
      {shelving.binNumber && (
        <>
          <dt className='font-bold'>Bin Number</dt>
          <dd data-testid='bin-number'>{shelving.binNumber}</dd>
        </>
      )}
    </dl>
  </div>
)

export default WarehouseShelvingInfo
